<template>
    <section v-if="creditStatementDataProps" class="h-auto sticky bottom-0 bg-greyBackground z-10 md:hidden">
        <section class="rounded p-4 pb-6 flex justify-center gap-8 md:gap-52">
            <div v-if="creditStatementDataProps?.settledTransactions?.availableSettledTxns > 0 || creditStatementDataProps?.pendingTransactions?.unpaidTxnCount > 0">
                <p @click="downloadStatement" class="underline text-hyperLinkColor text-sm font-myriad">Download Statement</p>
            </div>
        </section>
    </section>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CreditStatementCardBottom',
    components: {
    },
    props: {
        creditStatementDataProps: {
            type: Object,
        },
    },
    computed: {
        ...mapGetters([]),
    },
    data() {
        return {
            isLoading: false,
            creditStatementData: undefined
        };
    },
    mounted() {
        this.init();
    },
    watch: {
    },
    methods: {
        init() {
        },
        clearDues() {
            this.$router.push({ name: 'Credit Statement Payment Methods', params: { amount: this.creditStatementDataProps?.pendingTransactions.outstandingAmount, minimumDueAmount: this.creditStatementDataProps?.pendingTransactions.totalMinimumDue } });
        },
        downloadStatement() {
            this.$router.push({ name: 'Credit Statement download statement', params: { amount: this.creditStatementDataProps?.pendingTransactions.outstandingAmount, id: undefined } });
        },
    },
};
</script>
